import { Skeleton, Typography } from 'antd'

import { createUseStyles } from 'react-jss'
import { Link } from 'react-router-dom'
import { useCurrentUser } from '../../redux/slices/session'
import routes from '../../routes'

const { Text } = Typography

const useStyles = createUseStyles({
  userName: {
    margin: '0 10px',
  },
  skeleton: {
    width: '80px',
    marginRight: '10px',
  },
  userNameLink: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',

    textAlign: 'right',
  },
  userNameLinkContainer: {
    '@media (min-width: 1200px)': {
      maxWidth: '80%',
    }
  }
})

export default function ProfileLink() {
  const classes = useStyles()
  const { firstName, lastName, practice } = useCurrentUser()

  return (
    <div className={classes.userNameLinkContainer}>
      <Skeleton
        active
        className={classes.skeleton}
        loading={false}
        paragraph={false}
      >
        <Link to={routes.profile()} className={classes.userNameLink}>
          <Text className={classes.userName}>{`${firstName} ${lastName}`}</Text>
          {practice?.name && (
            <Text type="secondary" className={classes.userName}>
                {practice.name}
              </Text>
          )}
        </Link>
      </Skeleton>
    </div>
  )
}
